import React, { useState } from 'react';
import './App.css';
import Activities from "./Components/Activities";
import Events from "./Components/Events";
import Places from "./Components/Places";

function App() {
    const [typex, setType] = useState("activities");
    return (
    <div className="App">
        {(typex==="events" ||typex==="places") ? <button onClick={() => setType("activities")}>Aktiviteetit</button> : ''}
        {(typex==="activities" ||typex==="places") ? <button onClick={() => setType("events")}>Tapahtumat</button> : ''}
        {(typex==="activities" ||typex==="events") ? <button onClick={() => setType("places")}>Paikat</button> : ''}

        {(typex==="activities") ? <h1 className="subject" >Helsingin aktiviteetit</h1>
            : (typex==="events") ? <h1 className="subject" >Helsingin tapahtumat</h1>
            : (typex==="places") ? <h1 className="subject" >Helsingin paikat</h1>: '' }
        {(typex==="activities") ? <Activities /> : (typex==="events") ?  <Events /> : '' }
        {(typex==="places") ? <Activities /> : (typex==="places") ?  <Places /> : '' }
    </div>
  );
}
export default App;
